import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: any };

const initialState: State = { state: 'idle' };

@Injectable()
export class PersonnelBoardResolutionStore extends ComponentStore<State> {
  constructor() {
    super(initialState);
  }

  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<any>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
}
